import { lazy, type ComponentType } from "react";

/**
 * React.lazy for a named export: the page's module (and the libraries only it uses) becomes its own
 * chunk, fetched the first time the route renders. The layouts already wrap pages in <Suspense>.
 * Quality pass: the demo bundle was a single 3.8 MB chunk (1.1 MB gzip) loaded before the dashboard.
 */
export function lazyNamed<M, K extends keyof M>(
  load: () => Promise<M>,
  key: K,
) {
  return lazy(async () => ({
    default: (await load())[key] as M[K] & ComponentType<any>,
  }));
}
